import { useEffect, useState } from 'react';
import { ShieldAlert } from 'lucide-react';
import { getOrganizationIdFromSession } from '../lib/supabase';

/**
 * Banner persistente para sesiones de super-admin (auditor cross-org).
 * Aparece cuando el JWT tiene `app_metadata.org_id = '*'`.
 *
 * IMPORTANTE: eliminar el usuario audit@mibodega.local antes de salir a
 * producción. Este modo bypasea el filtro por organización en queries.
 */
export function SuperAdminBanner() {
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const check = async () => {
      const claim = await getOrganizationIdFromSession();
      if (!cancelled) {
        setIsSuperAdmin(claim?.allOrgs ?? false);
      }
    };
    check();
    const id = setInterval(check, 60_000);
    return () => {
      cancelled = true;
      clearInterval(id);
    };
  }, []);

  if (!isSuperAdmin) return null;

  return (
    <div
      className="flex items-center gap-2 border-b-2 border-amber-300 bg-amber-100 px-4 py-1.5 text-xs font-medium text-amber-900"
      role="alert"
    >
      <ShieldAlert className="h-4 w-4" />
      <span>
        MODO SUPER-ADMIN (auditor cross-org): estás viendo datos de TODAS las organizaciones. Solo
        para pre-producción. Elimina el usuario audit@mibodega.local antes de salir a producción.
      </span>
    </div>
  );
}
